/**
 * Page-level error banner for connection/server errors.
 * Text-only banner that persists until page refresh or a successful API call.
 */

const BANNER_ID = 'error-banner';

/**
 * Show a page-level error banner at the top of the page.
 * If a banner already exists, updates its text content.
 * @param {string} message - The message to display
 */
export function showErrorBanner(message) {
  let banner = document.getElementById(BANNER_ID);
  if (banner) {
    // Update existing banner text
    banner.textContent = message;
    return;
  }

  banner = document.createElement('div');
  banner.id = BANNER_ID;
  banner.textContent = message;
  banner.className =
    'fixed top-0 left-0 right-0 z-50 bg-red-50 border-b border-red-200 text-red-800 text-center py-3 px-4 text-sm';

  document.body.insertBefore(banner, document.body.firstChild);
}

/**
 * Hide and remove the error banner if it exists.
 */
export function hideErrorBanner() {
  const banner = document.getElementById(BANNER_ID);
  if (banner) {
    banner.remove();
  }
}
